import { render } from "./diagnosis-list.vue?vue&type=template&id=23a37b4e&scoped=true"
import script from "./diagnosis-list.vue?vue&type=script&lang=js"
export * from "./diagnosis-list.vue?vue&type=script&lang=js"

import "./diagnosis-list.vue?vue&type=style&index=0&id=23a37b4e&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a37b4e"]])

export default __exports__